/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT,
  payload: data,
});

export const setInterestOverrideReport = (data) => ({
  type: ActionTypes.GET_INTEREST_OVERRIDE_REPORT,
  payload: data,
});

export const refreshInterestOverride = () => ({
  type: ActionTypes.REFRESH_INTEREST_OVERRIDE,
  payload: {},
});
export const refreshInterestOverrideDisplay = () => ({
  type: ActionTypes.REFRESH_INTEREST_OVERRIDE_DISPLAY,
  payload: {},
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// API to get Interest override Reports data
export const getInterestOverrideReports = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.INTEREST_OVERRIDE_REPORTS, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.interestOverrideReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setInterestOverrideReport(response?.data?.interestOverrideReportVO)
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setInterestOverrideReport([]));
    });
};
